document.addEventListener('click', async (e) => {
  if(e.target.classList.contains('upsell-content__btn--product-page')) {
    const target = e.target

    const loading = target.querySelector('.upsell-content__btn--loading')
    const dinamicText = target.querySelector('.upsell-content__btn--dinamic-text')
    const variantId = target.previousElementSibling.value
    const cartCount = document.querySelector('.cart_count')

    loading?.classList.remove('hidden')

    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    }

    try {
      const res = await fetch('/cart/add', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })

      if(res.status != 200) throw new Error(`Failed to add product to cart: ${res.statusText}`)

      if(dinamicText) {
        target.classList.add('is-added')
        dinamicText.innerHTML = `
          Added to Cart
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none">
            <path d="M6.5501 12.8702L0.850098 7.17022L2.2751 5.74521L6.5501 10.0202L15.7251 0.845215L17.1501 2.27022L6.5501 12.8702Z" fill="black"/>
          </svg>
        `
      }
      cartCount.innerText = parseInt(cartCount.textContent) + 1
    } catch (error) {
      console.error(`Could not add product to cart: ${error}`)
    } finally {
      loading.classList.add('hidden')
    }
  }
})